import { all } from 'redux-saga/effects';

import { rootChannelsWatcher, rootMessagesWatcher } from '../Containers/Channels/sagas/';
import alertUserSagaWatcher from '../Containers/AlertUser/sagas';
import fbLoginRootSaga from '../sagas/firebase';
import rootDiscoverSagaWatcher from '../Containers/Discover/discoverSagas';
import rootEventsSaga from '../Containers/Events/sagas/index';
import rootEventwideSagaWatcher from './eventwide';
import rootFileSagaWatcher from './filesSaga';
import rootMomentsConfigWatcher from '../Containers/Moments/sagas/config';
import rootMomentsWatcher from '../Containers/Moments/sagas/data';
import rootNotificationsWatcher from '../Containers/Notifications/sagas';
import rootProfileWatcher from '../Containers/Profile/profileSagas';
import rootScheduleWatcher from '../Containers/Schedule/scheduleSagas';
import rootToastWatcher from './toast';
import rootUsersWatcher from '../sagas/users';
import rootUserInfoWatcher from '../sagas/userInfo';

import watchUserAuthentication from '../Containers/Auth/sagas/';
import {rootDashboardWatcher} from "../Containers/Dashboard/sagas";

export default function* rootSaga() {
    yield all([
        watchUserAuthentication(),
        rootEventwideSagaWatcher(),
        rootEventsSaga(),
        fbLoginRootSaga(),
        rootChannelsWatcher(),
        rootUsersWatcher(),
        rootUserInfoWatcher(),

        rootMomentsWatcher(),
        rootMessagesWatcher(),
        rootMomentsConfigWatcher(),
        rootProfileWatcher(),
        rootScheduleWatcher(),
        rootNotificationsWatcher(),
        alertUserSagaWatcher(),
        rootDiscoverSagaWatcher(),
        rootToastWatcher(),
        rootFileSagaWatcher(),
        rootDashboardWatcher()
    ]);
}
